import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountContactRecommendedListingsAdd implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountContactRecommendedListingsAddContainer";
    }
    render(){
        // console.log("contact recommended listings");
    }
}